import { render, staticRenderFns } from "./ItemCollapseView.vue?vue&type=template&id=af9a3ba2&scoped=true&"
import script from "./ItemCollapseView.vue?vue&type=script&lang=ts&"
export * from "./ItemCollapseView.vue?vue&type=script&lang=ts&"
import style0 from "./ItemCollapseView.vue?vue&type=style&index=0&id=af9a3ba2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af9a3ba2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af9a3ba2')) {
      api.createRecord('af9a3ba2', component.options)
    } else {
      api.reload('af9a3ba2', component.options)
    }
    module.hot.accept("./ItemCollapseView.vue?vue&type=template&id=af9a3ba2&scoped=true&", function () {
      api.rerender('af9a3ba2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/ItemCollapseView.vue"
export default component.exports